import React from 'react';

import ActionsAreaForDiscussionTopic from './ActionsAreaForDiscussionTopic/ActionsAreaForDiscussionTopic';
import ActionsAreaForActionItem from './ActionsAreaForActionItem/ActionsAreaForActionItem';

type Props = {
  uuid: string;
  parentUuid: string;
  isActionItem: boolean;
  isSection: boolean;
  onAttachmentInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onArrowUpClick: Function;
  onCommentButtonClick: Function;
  onHideAnimationTrigger?: Function;
};

function ActionsAreaForDesktop({
  uuid,
  parentUuid,
  isActionItem,
  isSection,
  onAttachmentInputChange,
  onArrowUpClick,
  onHideAnimationTrigger,
}: Props) {
  return (
    <>
      {isActionItem ? (
        <ActionsAreaForActionItem
          uuid={uuid}
          parentUuid={parentUuid}
          onAttachmentAdd={onAttachmentInputChange}
          onArrowUpClick={onArrowUpClick}
        />
      ) : (
        <ActionsAreaForDiscussionTopic
          uuid={uuid}
          isSection={isSection}
          onHideAnimationTrigger={onHideAnimationTrigger}
          onAttachmentInputChange={onAttachmentInputChange}
          onArrowUpClick={onArrowUpClick}
        />
      )}
    </>
  );
}

export default React.memo(ActionsAreaForDesktop);
